// Whether an office permits a flat program fee.
//
// The selectable amounts are NOT restated here. They arrive with the office config as
// `feeShape.options`, generated by app/services/payments/feeType.js, so the dropdown cannot
// offer an amount the API would reject — there is one list, not two that can drift.
//
// TWO SEPARATE DECISIONS. The OFFICE says whether a flat fee may be used for clients there at
// all — it adds the option, never removes the percentage, and sets no price. The REP picks the
// shape and the amount for each client at enrolment, because two clients in the same office are
// not owed the same number.

export const isFlatFeeAllowed = (customSettings) => customSettings?.flatFeeAllowed === true

// WS #2219702 (PACK, Hayden). Two office switches, offered while FLAT_FEE_ONLY_OFFICES is on:
// reps enrol on a flat fee only (needs the flat fee allowed), and the LSA leaves out the payment
// schedule. The enrolment screen does not read the flag; the server sends `feeShape.flatOnly`.
export const FLAT_FEE_ONLY_FLAG = 'FLAT_FEE_ONLY_OFFICES'

export const isFlatFeeOnlyOffice = (customSettings) =>
  isFlatFeeAllowed(customSettings) && customSettings?.flatFeeOnly === true

export const hidesLsaPaymentSchedule = (customSettings) => customSettings?.hideLsaPaymentSchedule === true
